import { Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { Modal } from '@/components/ui/Modal';
import { Separator } from '@/components/ui/Separator';

export interface ConfirmDeleteModalProps {
  company: string;
  hasApplication: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
}

export const ConfirmDeleteModal = ({
  company,
  hasApplication,
  onCancel,
  onConfirm,
  title,
}: ConfirmDeleteModalProps) => (
  <Modal onClose={onCancel} open size="md">
    <div className="flex items-start gap-3 px-5 pt-5 pb-3">
      <span className="flex size-9 shrink-0 items-center justify-center rounded-full bg-score-low/15 text-score-low">
        <Trash2 className="size-4" />
      </span>
      <div className="min-w-0 flex-1">
        <Modal.Title className="text-sm lg:text-base font-semibold text-foreground">
          Delete this job?
        </Modal.Title>
        <Modal.Description className="mt-1 text-xs/relaxed lg:text-sm/relaxed text-balance text-foreground-muted">
          <span className="text-foreground">{title}</span> at{' '}
          <span className="text-foreground">{company}</span> will be removed
          from your pipeline.
          {hasApplication
            && ' Any tailored resume and cover letter will also be deleted.'}{' '}
          This can't be undone.
        </Modal.Description>
      </div>
    </div>
    <Separator />
    <div className="flex items-center justify-end gap-1.5 bg-surface-sunken/40 px-5 py-3">
      <Button onClick={onCancel} size="sm" variant="ghost">
        Cancel
      </Button>
      <Button onClick={onConfirm} size="sm" variant="danger">
        <Trash2 className="size-3.5" /> Delete job
      </Button>
    </div>
  </Modal>
);
